import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { PageContext } from '../../../Context/PageProvider'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@material-ui/core'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import { mapErrorMessage } from '../../../Utilities/ApiHelper'

import { v4 as uuidv4 } from 'uuid'

const styles = theme => ({
  errorText: {
    color: theme.palette.error.main,
    marginTop: 20,
  },
})

export class GroupDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      errorMessage: null,
      value: null,
    }
  }

  componentDidMount() {
    if (this.props.group) {
      this.setState({
        value: this.props.group.getName(),
      })
    }
  }

  render() {
    const { loading, errorMessage } = this.state
    const { classes, t } = this.props
    return (
      <div>
        <Dialog open={this.props.open} onClose={this.props.onCancel} fullWidth maxWidth={'sm'} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">{this.props.group ? t('edit_group') : t('add_group')}</DialogTitle>
          <DialogContent>
            <ValidatorForm ref="form" onSubmit={this.handleSubmit.bind(this)} onError={errors => console.log('form error:', errors)}>
              <TextValidator
                label={t('name')}
                value={this.state.value}
                onChange={event => {
                  this.setState({ value: event.target.value })
                }}
                margin="dense"
                validators={['required']}
                errorMessages={[t('this_field_is_required')]}
                fullWidth
              />
              {errorMessage && <DialogContentText className={classes.errorText}> {errorMessage} </DialogContentText>}
            </ValidatorForm>
          </DialogContent>
          <DialogActions>
            <Button disabled={loading} onClick={this.props.onCancel} color="primary">
              {t('cancel')}
            </Button>
            <Button disabled={loading} onClick={() => this.refs.form.submit()} color="primary">
              {this.props.group ? t('edit_group') : t('add_group')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }

  handleSubmit() {
    const { t } = this.props
    const { value } = this.state
    this.setState({ loading: true, errorMessage: null })
    let uid = this.props.group ? this.props.group.getId() : uuidv4()
    this.context.authzService
      .upsertGroup(uid, value)
      .then(group => {
        this.setState({ value: null, loading: false })
        this.props.onSuccess(group)
      })
      .catch(error => {
        console.warn('upsertGroup error: ', error)
        this.setState({ loading: false, errorMessage: mapErrorMessage(error) })
      })
  }
}
GroupDialog.contextType = PageContext

GroupDialog.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool,
  group: PropTypes.any,
}

export default withTranslation()(withStyles(styles)(GroupDialog))
